var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9578 2.00292C18.4691 1.52645 17.8889 1.14848 17.2503 0.890606C16.6117 0.63273 15.9272 0.5 15.2359 0.5C14.5446 0.5 13.8601 0.63273 13.2215 0.890606C12.5829 1.14848 12.0026 1.52645 11.5139 2.00292L10.4997 2.9913L9.48554 2.00292C8.49842 1.04094 7.1596 0.500499 5.76361 0.500499C4.36761 0.500499 3.02879 1.04094 2.04168 2.00292C1.05456 2.96491 0.5 4.26964 0.5 5.6301C0.5 6.99055 1.05456 8.29528 2.04168 9.25727L3.05588 10.2457L10.4997 17.5L17.9436 10.2457L18.9578 9.25727C19.4467 8.78102 19.8346 8.21557 20.0992 7.5932C20.3638 6.97084 20.5 6.30377 20.5 5.6301C20.5 4.95642 20.3638 4.28935 20.0992 3.66699C19.8346 3.04463 19.4467 2.47917 18.9578 2.00292Z",
    fill: "#70AF19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/FilledHeart.d00c118ff3ec7b8a915e6437f9f66501.svg";
export { ForwardRef as ReactComponent };